import client from "./base"
import { IProductLog, ProductModel } from '../models/product'

export type ISearchEsProduct = {
    search: string
    from: number
    size: number
}

export const searchEsProduct = async (query: any) => {
    return await client.post(
        `${process.env.REACT_APP_API_BASE_URL}/es/proxy/product/_search`,
        query,
        {
            headers: {
                'Content-Type': 'application/json',
            }
        }
    ).then(res => {
        return {
            data: res?.data?.hits?.hits.map((product: any) => {
                return new ProductModel({
                    _id: product._id,
                    ...product._source
                })
            }),
            total: res?.data?.hits?.total?.value
        }
    })
}

export const getProductLogs = async (
    pharmacyId: string,
    productId: string,
    adminId: string
): Promise<IProductLog[]> => {
    const url = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/pharmacies/${pharmacyId}/inventory-items/${productId}/logs`
    const res = await client.get(url)
    return res.data
}